<div class="logo">

  <a class="simple-text logo-mini">

<!--    <div class="logo-title">-->

      <div class="logo-img">
        <img class="logo-img" src="./assets/img/Alobodo.png" style="width: 50px;height: auto; filter: brightness(0) invert(1);"/>

      </div>

<!--    </div>-->
  </a>
  <a class="simple-text logo-normal" >
    {{'Menu.Alobodo'|translate}}
  </a>

</div>
<div class="sidebar-wrapper">
  <ul class="nav" [ngStyle]="{'margin-left': this.apiService.currentDirection == 'ltr' ?  '15px' : '0'}">
    <!--    <li routerLinkActive="active" class="nav-item"><a [routerLink]="['/users']"><i class="fa fa-user"></i><p>{{'Menu.Users'|translate}}</p></a></li>-->
    <!--    <li routerLinkActive="active" class="nav-item"><a [routerLink]="['/technician']"><i class="fa fa-users"></i><p>{{'Menu.Technicians'|translate}}</p></a></li>-->
    <!--    <li routerLinkActive="active" class="nav-item"><a [routerLink]="['/moderator']"><i class="fa fa-user-times" aria-hidden="true"></i><p>{{'Menu.Moderator'|translate}}</p></a></li>-->
    <!--    <li routerLinkActive="active" class="nav-item"><a [routerLink]="['/agent']"><i class="fa fa-user-secret"></i><p>{{'Menu.Agents'|translate}}</p></a></li>-->
    <!--    <li routerLinkActive="active" class="nav-item"><a [routerLink]="['/payment']"><i class="fa fa-credit-card"></i><p>{{'Menu.Payments'|translate}}</p></a></li>-->
    <!--    <li routerLinkActive="active" class="nav-item"><a [routerLink]="['/feedback']"><i class="fa fa-sync"></i><p>{{'Menu.FeedBack'|translate}}</p></a></li>-->
    <!--    <li routerLinkActive="active" class="nav-item"><a [routerLink]="['/reports']"><i class="fa fa-file"></i><p>{{'Menu.Reports'|translate}}</p></a></li>-->
    <!--    <li routerLinkActive="active" class="nav-item"><a [routerLink]="['/audits']"><i class="fa fa-id-card"></i><p>{{'Menu.Audits'|translate}}</p></a></li>-->
    <!--    <li routerLinkActive="active" class="nav-item"><a [routerLink]="['/setting']"><i class="fa fa-cog" aria-hidden="true"></i><p>{{'Menu.GeneralSettings'|translate}}</p></a></li>-->
    <li
        [ngStyle]="{'text-align': this.apiService.currentDirection == 'ltr' ?  'left' : 'right', 'padding': this.apiService.currentDirection == 'ltr' ? '0 0px' : '0' }"
      routerLinkActive="active"
      *ngFor="let menuItem of menuItems"
      class="{{ menuItem.class}} nav-item" >
      <a *ngIf="isAuthorized(menuItem.role, menuItem.title)" [routerLink]="[menuItem.path]"
         [ngStyle]="{'margin': this.apiService.currentDirection == 'ltr' ?  '0px 0px 0' : '0px 15px 0' }">
        <i class="fa  {{ menuItem.icon }}"></i>
        <p>{{ 'Sidebar.' + menuItem.title | translate }}
          <span *ngIf="menuItem.id == 126 && !msgCount == 0" 
          [ngStyle]="{'float': this.apiService.currentDirection == 'ltr' ?  'right' : 'left'}"
          class="badge count-badge"> {{msgCount}} </span>
        </p>
        
      </a>
    </li>

  </ul>
  <!--  <div style="text-align: center; position: absolute; bottom: 20%;color: black">-->
  <!--    <a style="cursor: pointer;" href="https://medis.land/">-->
  <!--      <img  src="../../../../assets/img/Medis.png" style="width: 17%;height: auto; padding-bottom: 5px; cursor: pointer;"/>-->
  <!--    </a>-->


  <!--    <div class=" copyright" [ngStyle]="{'font-family' :this.apiService.currentDirection == 'ltr'? 'sans-serif': 'vazir-regular'}">-->
  <!--      <a href="https://medis.land" target="_blank"></a>-->
  <!--      {{ 'Menu.PoweredyMedis' | translate }}  &copy; {{ test | date: "yyyy" }}-->
  <!--    </div>-->
  <!--  </div>-->


</div>
<div class="powered">
  <div style="text-align: center;color: black;">
    <a style="cursor: pointer;" href="https://medis.land/">
      <img src="../../../../assets/img/medis.png"
           style="width: 15%;height: auto; padding-bottom: 3px; cursor: pointer;"/>
    </a>

    <div class=" copyright"
         [ngStyle]="{'font-family' :this.apiService.currentDirection == 'ltr'? 'sans-serif': 'vazir-regular'}">
      <a href="https://medis.land" target="_blank"></a>
      {{ 'Menu.PoweredByMedis' | translate }} &copy; {{ test | date: "yyyy" }}
    </div>
  </div>
</div>
